import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';
import img from '../../images/Progress1.svg';
import img1 from '../../images/heart.svg';
import img2 from '../../images/upload.svg';

export default function ConnectPage() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/mapyourdata');
  };

  return (
    <div className='connect-container-bg'>
      <div className='connect-container-main'>
        <div className='connect-steps-container'>
          <div>
            <h3>1 <span>/ &nbsp;3 steps</span></h3>
          </div>
          <div>
            <h5>33%</h5>
          </div>
        </div>
        <div className='connect-progress'>
          <img src={img} alt="" />
        </div>
        <h2>Connect your data</h2>
        <p>Let's set up your patient data so you can start using it right away.</p>
        <div className='social-login google glucose-monitor'>
          <a href="">
            <span><img src={img1} alt="" /></span>
            <span>Continuous Glucose Monitor</span>
          </a>
        </div>
        <h4>OR</h4>
        <div className='connect-drop-files'>
          <img src={img2} alt="" />
          <h2>Drag and drop files here,</h2>
          <p>Supported formats: .csv, .xlsx</p>
        </div>
        <div className='delete-btn'>
          <div className='connect-csv-file'>
            <input type="text" placeholder='untitled.csv' />
          </div>
          <div className='connect-delete-btn'>
            <button>Delete</button>
          </div>
        </div>
        <div className='login-button-container next-button'>
          <button onClick={handleNext}>Next</button>
        </div>
        <h5>Cancel</h5>
      </div>
    </div>
  );
}
